import React from "react";
import moment from "moment-timezone";
import StatusIcon from "../components/common/StatusIcon";
import { STATUS_ICON_COLORS, STATUS_ICON_TYPES } from "../constants";

const getValidityStatusColor = (status) => {
  switch (status) {
    case "active":
      return STATUS_ICON_COLORS.GREEN;
    case "valid":
      return STATUS_ICON_COLORS.GREEN;
    case "future":
      return STATUS_ICON_COLORS.LIGHT_BLUE;
    case "expired":
      return STATUS_ICON_COLORS.GREY;
    default:
      return STATUS_ICON_COLORS.GREY;
  }
};
const dateValidity = (date, timezone) => {
  const tz = timezone || "UTC";
  return (
    <>
      <span className="align-top">
        <StatusIcon color={getValidityStatusColor(date.status)} type={STATUS_ICON_TYPES.CIRCLE} />
      </span>
      {!date.fromDate && !date.toDate && " - "}
      {date.fromDate && !date.toDate && "From "}
      {date.fromDate
        ? moment
            .tz(`${date.fromDate} ${date.startTime}`, "YYYY-MM-DD HH:mm", tz)
            .format("MMM DD, YYYY")
        : ""}
      {date.fromDate && date.toDate && " - "}
      {!date.fromDate && date.toDate && "Till "}
      {date.toDate
        ? moment.tz(`${date.toDate} ${date.endTime}`, "YYYY-MM-DD HH:mm", tz).format("MMM DD, YYYY")
        : ""}
    </>
  );
};

export default dateValidity;
